<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md [header]="'OPERATIONS.OPERATIONS' | transloco">
    <sbnb-operations-subnav></sbnb-operations-subnav>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <app-feature-flag-tabs>
      <sbnb-page-header navTabs>
        <h2 class="mb-0">Teammates</h2>
      </sbnb-page-header>
      <h2 class="mb-0">Teammates</h2>
    </app-feature-flag-tabs>
    <sbnb-helptext-wrapper
      class="helptext-wrapper-type-content"
      [area]="'content'"
      [pageId]="'ops-team'"></sbnb-helptext-wrapper>

    <sbnb-helptext-wrapper [area]="'intro'" [pageId]="'ops-team'"></sbnb-helptext-wrapper>

    <div class="rules__filters-container" fxLayout fxLayout.lt-md="column" fxLayoutGap="16px">
      <sbnb-filter
        #filterComponent
        *ngIf="segmentFilterDefaults"
        fxFlex
        componentName="teammates"
        [defaultFilters]="segmentFilterDefaults"
        [hideSaveSegment]="true"
        (filterChanged)="handleFilterChanged($event)"
        (reset)="filterReset()"></sbnb-filter>
      <sbnb-search-bar
        placeholderText="Search..."
        [initialVal]="searchCriteria"
        (searchChanged)="searchUpdated($event)"></sbnb-search-bar>
      <button
        type="submit"
        mat-flat-button
        class="button__small button__add-new"
        [routerLink]="['/operations/team/create']">
        + Add new
      </button>
    </div>

    <ng-container *ngIf="team">
      <sbnb-no-items
        *ngIf="team.length === 0"
        icon="co-host"
        text="No teammates found matching these filters"
        [buttons]="[{ id: 'new', label: 'Add new teammate' }]"
        (button)="openNewTeam()"></sbnb-no-items>

      <div *ngIf="team && team.length > 0" class="rules__container">
        <div fxLayout fxLayoutGap="19px" fxHide.lt-md class="rules__rule-header">
          <div fxFlex="20px">Pic</div>
          <div fxFlex="35">Name</div>
          <div fxFlex>Company</div>
          <div fxFlex>Location</div>
          <div fxFlex>Preferred properties</div>
          <div fxFlex="110px">Contact</div>
        </div>

        <a
          *ngFor="let member of team"
          fxLayout
          class="rules__rule-container"
          fxLayoutAlign="start center"
          fxLayoutGap="16px"
          [class.bounced]="member.bounced"
          [routerLink]="['/operations/team/member/' + member.uuid]">
          <sbnb-team-icon fxHide.lt-md [member]="member"></sbnb-team-icon>

          <div fxFlex="35" fxLayout fxLayoutAlign="start center" fxLayoutGap="16px" class="rule__title">
            <div fxLayout="column">
              <span class="ellipsis">{{ member.name }}</span>
              <span *ngIf="member.bounced" class="text__xsmall raspberry-darker">Email bounced</span>
            </div>
            <sbnb-team-role-badge fxHide.lt-md [member]="member"></sbnb-team-role-badge>
          </div>

          <div fxFlex fxLayout fxLayoutAlign="start center" fxLayoutGap="14px">
            <span class="ellipsis text__small" [style.color]="!member.is_company ? '#B3AFBB' : null">
              {{ member.is_company ? member.company_name : 'Individual' }}
            </span>
          </div>

          <div fxHide.lt-md fxFlex class="rule__when" fxLayoutAlign="start center" fxLayoutGap="8px">
            <span class="text__small" [style.color]="!member.address.country ? '#B3AFBB' : null" fxFlex>
              {{ member.address.country ? member.address.city + ' ' + member.address.country : 'Unknown' }}
            </span>
          </div>

          <div fxFlex fxFlex.lt-md="none" fxLayoutAlign="start center" fxLayoutGap="8px">
            <sbnb-avatar-group
              [items]="member.property_list"
              [allItems]="member.all_properties"
              [itemsForLabel]="member.name"></sbnb-avatar-group>
          </div>

          <div fxHide.lt-md fxLayout fxLayoutGap="16px" fxLayoutAlign="start center">
            <sbnb-icon
              icon="phone"
              [ngClass]="member.phone_number ? 'text-raspberry-darker' : 'text-smoke-darker'"></sbnb-icon>
            <sbnb-icon
              icon="email"
              [size]="18"
              [ngClass]="member.email ? 'text-raspberry-darker' : 'text-smoke-darker'"></sbnb-icon>
          </div>

          <div fxHide.lt-md fxLayout fxLayoutGap="8px">
            <sbnb-more-menu-trigger [matMenuTriggerFor]="actionsMenu" [suppressClick]="true"></sbnb-more-menu-trigger>
          </div>

          <mat-menu #actionsMenu="matMenu">
            <button mat-menu-item (click)="deletePrompt(member)">
              <span fxLayoutAlign="start center" fxLayoutGap="6px">
                <img src="/assets/iconography/delete.svg" alt="Delete" />
                <span>Delete</span>
              </span>
            </button>
          </mat-menu>
        </a>
      </div>

      <sbnb-pagination
        *ngIf="paginationData && !loading && paginationData.page_numbers.total_pages > 1"
        position="end"
        [pageCount]="paginationData.page_numbers.total_pages"
        [currentPage]="paginationData.page_numbers.this_page"
        (pageChanged)="handlePageChanged($event)"></sbnb-pagination>
    </ng-container>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Operations'">
  <sbnb-operations-subnav></sbnb-operations-subnav>
</sbnb-mobile-sidebar>
